import { render } from "./DetailDipesan.vue?vue&type=template&id=35a9bdae"
import script from "./DetailDipesan.vue?vue&type=script&lang=js"
export * from "./DetailDipesan.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__